<template>
    <div class="employee-craft">
        <div class="uk-grid uk-margin-small-top uk-margin-small-bottom uk-margin-small-left uk-margin-small-right">
            <div class="uk-width-1-2 uk-padding-remove-left">
                <span class="uk-form-label">Craft</span>
            </div>
            <div class="uk-width-1-3 uk-padding-remove-left">
                <span class="uk-form-label">Craft Code</span>
            </div>
            <div class="uk-width-1-6 uk-padding-remove-left">

            </div>
        </div>
        <div v-for="craft in crafts" class="uk-grid uk-margin-small-top uk-margin-small-bottom uk-margin-small-left uk-margin-small-right employee-craft-row">
            <div class="uk-width-1-2 uk-padding-remove-left">
                <input class="uk-input uk-disabled uk-margin-small-right" disabled v-model="craft.skill.name" />
            </div>
            <div class="uk-width-1-3 uk-padding-remove-left">
                <input class="uk-input uk-disabled" disabled v-model="craft.payCode.code" />
            </div>
            <div class="uk-width-1-6 uk-padding-remove-left controls">
                <a href="#" :uk-toggle="'target: #' + formModalId" @click="activateEditModal(craft.id)"><i class="fas fa-edit"></i></a>
                <a href="#" :uk-toggle="'target: #' + deleteModalId"  @click="activateDeleteModal(craft.id)"><i class="fas fa-trash"></i></a>
            </div>
        </div>
        <div class="uk-margin-small-top uk-margin-small-bottom uk-margin-small-left uk-margin-small-right">
            <a :uk-toggle="'target: #' + formModalId"><i class="fas fa-plus-circle"></i> Add Another Craft</a>
        </div>
    </div>
</template>

<script>
    export default {
        name: "EmployeeCraft",

        props: {
            uid:Number,
            formModalId:String,
            formRef:String,
            deleteModalId:String,
            deleteFormRef:String
        },

        data() {
            return {
                crafts:[]
            };
        },
        mounted() {
            this.loadCrafts();
        },
        methods:{
            loadCrafts(){
                axios.get("/api/employee/get/" + this.uid + "/craft/list")
                    .then((pack) => this.updateCrafts(pack));
            },
            startSearch(){//alias for other items that call this function
                this.loadCrafts();
            },
            updateCrafts(pack){
                this.crafts = pack.data.data;
            },
            activateEditModal(id){
                this.$root.$refs[this.formRef].loadForm(id);
            },
            activateDeleteModal(id){
                this.$root.$refs[this.deleteFormRef].loadForm(id);
            }
        }
    }
</script>
